import { useEffect } from "react";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import useUploadPayslipDocumentFinalizeApiService from "../services/api/FinalizePayslipDocumentsApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

export default function FinalizePayslipDocumentProcessingHook(
  documentName: string
): { finalizeDocument: (employerId: number, jobId: number) => void } {
  const { showToast } = useToasts();
  const { isSuccess, isError, mutate, error } =
    useUploadPayslipDocumentFinalizeApiService();

  const finalizeDocument = (employerId: number, jobId: number): void => {
    mutate({ job_id: jobId, employer_id: employerId });
  };

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "finalize_payslip_upload_failed",
        data: { document_name: documentName, message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({
        strapiId: "finalize_payslip_upload_success",
        data: { document_name: documentName },
      });
      queryClient.invalidateQueries(["DocumentUploadListApiService"]).then();
    }
  }, [isSuccess]);

  return {
    finalizeDocument,
  };
}
